import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { translate } from '../assets/js/functions';
import Layout from "../components/Layout";
import ReactPlayer from 'react-player'
import { BrowserView, MobileView } from 'react-device-detect';
import PosterMobile from "../assets/img/imatge-carrega-video-intro-mobile.jpg";
import PosterDesktop from "../assets/img/imatge-carrega-video-intro.jpg";
import VideoMobile from "../assets/video/video-intro-mobile-medium.mp4";
import VideoDesktop from "../assets/video/video-intro-desktop-medium.mp4";
import IcoPlay from "../assets/img/ico-play.svg";
import IcoStop from "../assets/img/ico-stop.svg";
import IcoVolum from "../assets/img/ico-volum.svg";
import IcoMute from "../assets/img/ico-mute.svg";


export default function Intro(){

    const [pause, setPause] = useState(false);
    const [mute, setMute] = useState(true);

    function pauseToggle() {
        setPause(!pause);
    }

    function muteToggle() {
        setMute(!mute);
    }

    return (
        <Layout pageMeta={{

        }}>
            <div className="video-intro w-100 is-relative">
                <BrowserView style={{"width":"100%", "height":"100%"}}>
                    <ReactPlayer
                        playing={!pause}
                        width="100%"
                        height="100%"
                        loop={true}
                        muted={mute}
                        url={VideoDesktop}
                        playsinline={true}
                        config={{
                            attributes: { poster: PosterDesktop }
                        }}
                    />
                </BrowserView>
                <MobileView>
                    <ReactPlayer
                        playing={!pause}
                        width="100%"
                        height="100%"
                        loop={true}
                        muted={mute}
                        url={VideoMobile}
                        playsinline={true}
                        config={{
                            attributes: { poster: PosterMobile }
                        }}
                    />
                </MobileView>
                {/*<video autoPlay poster={PosterMobile} className="is-hidden-tablet w-100">
                    <source src="{videoMobile} type="video/mp4"/>
                </video>
                <video autoPlay={true} mute={mute} poster={PosterDesktop} className="is-hidden-mobile w-100">
                    <source src={VideoDesktop} type="video/mp4"/>
                </video>*/}
                <div className="video-controls is-flex is-justify-content-space-between is-align-items-center w-100 px-7">
                    <div className="is-flex gap-2">
                        <button onClick={(event) => {event.preventDefault();pauseToggle()}} type="button" className="button is-text p-0">
                            {pause?
                            <img src={IcoPlay} alt={translate('Reprodueix')} width="44" height="44"/>
                            :
                            <img loading="lazy" src={IcoStop} alt={translate('Pausa')} width="44" height="44"/>
                            }
                        </button>
                        <button onClick={(event) => {event.preventDefault();muteToggle()}} type="button" className="button is-text p-0">
                            {mute?
                            <img src={IcoMute} alt={translate('Silencia')} width="44" height="44"/>
                            :
                            <img loading="lazy" src={IcoVolum} alt={translate('Activa el so')} width="44" height="44"/>
                            }
                        </button>
                    </div>
                    <Link to="/home" className="button button--icon button--saltar">{translate('Saltar intro')}</Link>
                </div>
            </div>
        </Layout>
    )
}
